import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/sales-over-time-icon.svg'


const _hoisted_1 = { class: "row align-items-" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { style: {"margin":"-7px -20px -14px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"col-lg-6 mt-4\"><div class=\"d-flex align-items-center mb-4\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><div class=\"rounded-2 text-center\" style=\"background-color:#dde4ff;width:44px;height:44px;line-height:44px;\"><img src=\"" + _imports_0 + "\" alt=\"sales-over-time-icon\"></div></div><div class=\"flex-grow-1 ms-10\"><span>Sales Over Time</span><h3 class=\"fs-24 fw-semibold mb-0\">$120,000</h3></div></div><span class=\"text-success-50 p-2 py-1 d-inline-block rounded-1 ms-10\" style=\"background-color:#d8ffc8;\"> +9.1% </span></div><p style=\"line-height:1.44;max-width:284px;\"> Sales have shown a positive trend, with a significant increase of 9.1% over the previous month. </p></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "bar",
              height: "197",
              options: _ctx.salesOverTime,
              series: _ctx.sales
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}